import { FC } from 'react';
import { PaymentType } from '../../../helpers/constants';

type Props = {
  amount: number;
  charges?: number;
  type?: PaymentType;
  repaymentCount?: number;
};
const PaymentSummary: FC<Props> = ({ amount, type, charges = 0, repaymentCount = 1 }) => {
  return (
    <div className='bg-light p-5 payment-summary'>
      <div className='row mb-3'>
        <label className='col-lg-6 text-muted'>{type === PaymentType.REPAYMENT ? 'Repayment Amount' : 'Loan Amount'}</label>

        <div className='col-lg-6 fv-row text-end fs-4 text-primary fw-bolder'>{amount.toLocaleString()}</div>
      </div>

      <div className='row mb-3'>
        <label className='col-lg-6 text-muted'>Charges</label>

        <div className='col-lg-6 fv-row text-end fs-4 text-primary fw-bolder'>{charges.toLocaleString()}</div>
      </div>

      <div className='row mb-3'>
        <label className='col-lg-6 text-muted'>Total</label>

        <div className='col-lg-6 fv-row text-end fs-4 text-primary fw-bolder'>{(amount * repaymentCount + charges).toLocaleString()}</div>
      </div>
    </div>
  );
};

export default PaymentSummary;
